import urlParamsToObject from '../../utils/url/urlParamsToObject';
import removePrefixFromParams from '../../utils/url/removePrefixFromParams';
import getParamFromUrl from './_getParamFromUrl';

/**
 * Indicates if the zipcode has changed in the URL
 *
 * @return {String|Boolean} The new zipcode detected or false
 */
function checkZipCodeChangesInUrl() {
  // gets all search parameters in the current URL
  const urlParams = removePrefixFromParams(urlParamsToObject(), 'p.');
  // Update location from URL parameters
  const zipcode = getParamFromUrl(['zipcode', 'GeoLocation-zipCode', 'zip'], urlParams);
  if (zipcode) {
    return zipcode;
  }

  return false;
}

export default checkZipCodeChangesInUrl;
